import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getDisplayName } from '@grandvisionhq/utils';

function withServerRouteFormatters(localRouteFormatters) {
    return (PageComponent)=>{
        const displayName = getDisplayName(PageComponent);
        const WithServerRouteFormatters = (pageProps)=>{
            return /*#__PURE__*/ React.createElement(PageComponent, swcHelpers.extends({}, pageProps));
        };
        WithServerRouteFormatters.getInitialProps = function() {
            var _ref = swcHelpers.asyncToGenerator(function*(appContext) {
                let pageProps = {};
                if (PageComponent.getInitialProps) {
                    pageProps = yield PageComponent.getInitialProps(swcHelpers.objectSpread({}, appContext, {
                        localRouteFormatters
                    }));
                }
                if (typeof PageComponent.getInitialProps === 'function') {
                    return pageProps;
                }
                return {};
            });
            return function(appContext) {
                return _ref.apply(this, arguments);
            };
        }();
        WithServerRouteFormatters.displayName = `WithServerRouteFormatters(${displayName})`;
        return WithServerRouteFormatters;
    };
}

export { withServerRouteFormatters };
//# sourceMappingURL=with-server-route-formatters.js.map
